import { FourRowEightSlotLayout } from './FourRowEightSlotLayout';
import { FullPageLayout } from './FullPage';
import { SideBySideLayout } from './SideBySide';
import { TitlePageLayout } from './TitlePage';
import { TwoRowFourSlotLayout } from './TwoRowFourSlotLayout';
import { TwoRowLayout } from './TwoRowLayout';
import { TwoRowThreeSlotLayout } from './TwoRowThreeSlotLayout';

export const SmartReportLayouts = [
  TitlePageLayout,
  FullPageLayout,
  SideBySideLayout,
  TwoRowThreeSlotLayout,
  TwoRowFourSlotLayout,
  FourRowEightSlotLayout,
  TwoRowLayout,
];
